import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import globalReducer from "src/features/global/globalSlice";
import productsReducer from "src/features/products/productsSlice";
import highlightedProductReducer, {
  injectStore,
} from "src/features/highlighted-product/highlightedProductSlice";
import productModalReducer from "src/features/product-modal/productModalSlice";
import eventsReducer from "src/features/events/eventsSlice";
import videoReducer from "src/features/video/videoSlice";
import CombinedProductModalReducer from "src/features/combined-product/combinedProductSlice";
import { apiSlice } from "./apiSlice";
import { setupListeners } from "@reduxjs/toolkit/query";

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    products: productsReducer,
    productModal: productModalReducer,
    combinedProductModal: CombinedProductModalReducer,
    global: globalReducer,
    highlightedProduct: highlightedProductReducer,
    events: eventsReducer,
    video: videoReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

injectStore(store);
setupListeners(store.dispatch);
